export default "__VITE_ASSET__7cSkw8ek__"